/**
 *
 * DragDropOverlay
 *
 */

import React, { useEffect, useRef, useState } from 'react';
// import PropTypes from 'prop-types';
// import styled from 'styled-components';

import { FormattedMessage } from 'react-intl';
import messages from './messages';

function DragDropOverlay() {

  let localdata = useRef();
  let [updates, updateOverlay] = useState(0);

  const forceUpdate = () => {
    updateOverlay(updates++);
  }

  useEffect(() => {    
    if (!localdata.current) {
      localdata.current = {};
      localdata.current.elementToCallbackMap = {};
      localdata.current.droppableEntities = [];
      localdata.current._draggedElement = null;
      localdata.current._prevDragX = null;
      localdata.current._prevDragY = null;
      localdata.current._prevRotation = null;
      localdata.current.uiSheetClassStyles = {};
      localdata.current.dropzoneCallbacksOnDrag = [];
      localdata.current.uiSheetIndex = 0;
    }
    localdata.current.dragStyle = (function () {
      var style = document.createElement("style");
      style.appendChild(document.createTextNode(""));
      document.head.appendChild(style);
      return style;
    })();
    localdata.current.dragSheet = localdata.current.dragStyle.sheet;
    window.isDragEventActive = () => {
      return localdata.current != null && localdata.current._draggedElement != null; 
    }

    window.createDraggableEntity = (element, data, onDragEnd, onDragMove) => {
      localdata.current._draggedElement = element;
      localdata.current.dragData = data;
      localdata.current.dragRelease = false;
      localdata.current.foundDragTarget = false;
      localdata.current.onDragEndCallback = onDragEnd;
      localdata.current.onDragMoveCallback = onDragMove;
      forceUpdate();

      Object.keys(localdata.current.dropzoneCallbacksOnDrag).forEach(id => {
        let onDrag = localdata.current.dropzoneCallbacksOnDrag[id];
        if (onDrag) {
          onDrag();
        }
      });
    }

    window.addDroppableEntity = (element, onDrop, onDrag, dropData) => {
      localdata.current.droppableEntities.push(element);
      const onDropCallback = (dragData, dropData) => {
        onDrop(dragData, dropData);
      }

      localdata.current.dropzoneCallbacksOnDrag[element.id] = onDrag;

      localdata.current.elementToCallbackMap[element.id] = {
        callback: onDropCallback,
        dropData: dropData
      };
    }

    window.removeDroppableEntity = (element) => {
      let index = localdata.current.droppableEntities.indexOf(element);
      if (index > -1) {
        localdata.current.droppableEntities.splice(index, 1);
        delete localdata.current.elementToCallbackMap[element.id];
        delete localdata.current.dropzoneCallbacksOnDrag[element.id]
      }
    }

    const updateInternalStyle = (classStyle) => {
      var rules = localdata.current.dragSheet.cssRules;
      var index = classStyle.index;
      var style = classStyle.style;
      if (rules[index].style.cssText != style) {
        rules[index].style.cssText = style;
      }
    }

    const updateSheet = (className, style) => {
      let sheet = localdata.current.dragSheet;
      let classStyle = localdata.current.uiSheetClassStyles[className];
      if (style == null || style == undefined) {
        style = "";
      } else {
        if (style.charAt(style.length - 1) != ";") {
          style += ";";
        }
      }

      if (!classStyle) {
        localdata.current.uiSheetClassStyles[className] = {};
        classStyle = localdata.current.uiSheetClassStyles[className];
        sheet.insertRule(className + "{" + style + "}", localdata.current.uiSheetIndex);
        classStyle.index = localdata.current.uiSheetIndex;
        localdata.current.uiSheetIndex++;
      } else {
        if (classStyle.style != style) {
          classStyle.style = style;
        }
        updateInternalStyle(classStyle);
      }
    };

    const easeToValue = (currentValue, finalValue, ease) => {
      if (Math.abs(currentValue - finalValue) < 0.001) {
        return finalValue;
      } else {
        return (currentValue + (finalValue - currentValue) * ease);
      }
    }

    const handleMouseMove = (e) => {
      if (localdata.current._draggedElement && !localdata.current.dragRelease) {
        let x = e.clientX;
        let y = e.clientY;
        if (!localdata.current._prevDragX) {
          localdata.current._prevDragX = x;
        }
        if (!localdata.current._prevDragY) {
          localdata.current._prevDragY = y;
          localdata.current.dragInterval = setInterval(() => {
            localdata.current._prevRotation = easeToValue(localdata.current._prevRotation, 0, 0.1);
            updateSheet(".dragged-ui-element", "z-index: 100000000; position: absolute; transform: translate3d(" + (localdata.current.mouseX - 5) + "px, " + (localdata.current.mouseY - 5) + "px, 0px) rotate(" + localdata.current._prevRotation + "deg)");
          }, 13)
        }
        let rotationAdjustment = (localdata.current._prevDragY - y) * 0.1;
        if (x > localdata.current._prevDragX) {
          rotationAdjustment += (x - localdata.current._prevDragX) * 0.2;
        }
        localdata.current._prevDragY = y;
        localdata.current._prevDragX = x;
        localdata.current._prevRotation = (localdata.current._prevRotation ? localdata.current._prevRotation : 0) + rotationAdjustment;
        if (localdata.current._prevRotation > 5) {
          localdata.current._prevRotation = 5;
        } else if (localdata.current._prevRotation < -5) {
          localdata.current._prevRotation = -5;
        }

        updateSheet(".dragged-ui-element", "z-index: 100000000; position: absolute; transform: translate3d(" + (x - 5) + "px, " + (y - 5) + "px, 0px) rotate(" + localdata.current._prevRotation + "deg)");
        localdata.current.mouseX = x;
        localdata.current.mouseY = y;
        if (localdata.current.onDragMoveCallback) {
          localdata.current.onDragMoveCallback(e);
        }
      }
    }

    const handleMouseUp = (e) => {
      if (window.disqualifiedDroppable) {
        delete window.disqualifiedDroppable;
      }
      
      if (localdata.current._draggedElement) {
        localdata.current._draggedElement = undefined;
        let dropzone = window.currentDropzone;
        if (dropzone) {
          localdata.current.foundDragTarget = true;
          let dropzoneProps = localdata.current.elementToCallbackMap[dropzone.id];
          if (dropzoneProps && dropzoneProps.callback) {
            dropzoneProps.callback(localdata.current.dragData, dropzoneProps.dropData, e);
          }
        }

        if (localdata.current.onDragEndCallback) {
          localdata.current.onDragEndCallback(e);
          localdata.current.onDragEndCallback = undefined;
        }

        if (localdata.current.dragInterval) {
          clearInterval(localdata.current.dragInterval);
        }
        localdata.current.dragData = undefined;
        localdata.current.dragRelease = true;
        localdata.current._prevDragX = undefined;
        localdata.current._prevDragY = undefined;
        localdata.current.styleCallback = undefined;
        localdata.current._prevRotation = 0;
        forceUpdate();
      }
    }

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    document.addEventListener('gesturestart', function (e) { e.preventDefault(); });
  }, [])

  let draggedElementVisual;

  if (localdata.current && localdata.current._draggedElement) {
    let elemState = "";
    if (localdata.current.foundDragTarget && localdata.current.dragRelease) {
      elemState = "target-exit";
    } else if (!localdata.current.foundDragTarget && localdata.current.dragRelease) {
      elemState = "no-target-exit";
    }

    draggedElementVisual = <div className="dragged-ui-element">
      <div className={`dragged-ui-element-transform ${elemState}`}>
        {localdata.current._draggedElement}
      </div>
    </div>
  }

  return (
    <div id="drag_drop_overlay" style={{ zIndex: 10000000000, position: 'fixed', left: '0px', right: '0px', top: '0px', bottom: '0px', pointerEvents: 'none' }}>
      {/* {draggedElementVisual} */}
    </div>
  );
}

DragDropOverlay.propTypes = {};

export default DragDropOverlay;
